import Service from "../../service/index";

const Common = {
  namespaced: true,
  state: {
    data: [],
    dataSearchBarChart:[],
    amountStatSearchBarChart: [],
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
      state.dataSearchBarChart = data[0];
      state.amountStatSearchBarChart = data[0];
    },
  },
  actions: {
    getDataSearchTools({ commit }) {
      return Service.Common.getDataSearchTools().then(data => {
        commit('SET_DATA', data)
        return data;
      })

      // return Service.Auth.login(data).then(response =>{
      //   commit("SET_USER_LOGIN", response);
      // });
    },
    getLike({commit}) {
      return Service.Common.getLike().then(res => {
        return res;
      })
    },
  }
};

export default Common;
